import { Popover, styled } from '@mui/material';
import { spaceCadet } from '../../../../utils/colors';

const StyledPopover = styled(Popover)({
  marginTop: 8,
  '& .MuiPaper-root': {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: '20px 0px',
    maxHeight: 500,

    '& .MuiBox-root.header': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 8,
      padding: '0px 24px',

      '& .MuiTypography-root': {
        lineHeight: '16px',
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'uppercase',
        color: spaceCadet[500],
      },
      '& .MuiButton-root': {
        lineHeight: '16px',
        fontSize: 12,
        color: spaceCadet[800],
        textDecoration: 'underline',
        textTransform: 'none',
      },
    },
  },
});
export default StyledPopover;
